import axios from 'axios';

import { api, throwApiError } from "../../api/api";

export const uploadFefoFile = async (file: File): Promise<Blob> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bebidas/fefo-control`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      if (error.response?.data instanceof Blob) {
        const errorText = await error.response.data.text();
        try {
          const errorJson = JSON.parse(errorText.trim());
          throw { message: errorJson.message || 'Erro ao enviar o arquivo' };
        } catch {
          const errorJson = JSON.parse(errorText.trim());
          throw { message: errorJson.message };
        }
      }
      throw { message: 'Erro ao enviar o arquivo. Tente novamente.' };
    } else {
      throw { message: 'Erro desconhecido ao enviar o arquivo.' };
    }
  }
};

export const uploadShelfControlFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/bebidas/shelf-control`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao enviar arquivo');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

// Lojas vêm do módulo de lojas, que exige token: vão pela instância `api`
// (com o interceptor de Authorization), e não pelo axios puro deste arquivo.
export const createStore = async (storeData: { nomeFantasia: string; endereco: string }) => {
  try {
    const { data } = await api.post("/stores", storeData);
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao criar a loja");
  }
};

export const createProducts = async (productsData: { nomeProduto: string; sap: string }[]) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/products`,
      productsData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao cadastrar o produto');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

export const getRelatorioShelfExcel = async (
  filtros: { inicio?: string; fim?: string; lojas?: string[] }
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/bebidas-filtros/relatorio-shelf-excel`,
      {
        params: filtros,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

      return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao gerar o relatório SHELF Excel');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};

export const getRelatorioFefoExcel = async (
  filtros: { inicio?: string; fim?: string; lojas?: string[] }
) => {
  try {
    console.log('Enviando requisição para gerar relatório FEFO Excel:', {
      url: `${process.env.REACT_APP_BACKEND_URL}/bebidas-filtros/relatorio-fefo-excel`,
      filtros,
    });

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/bebidas-filtros/relatorio-fefo-excel`,
      {
        params: filtros,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    console.log('Relatório FEFO Excel recebido com sucesso:', {
      status: response.status,
      contentType: response.headers['content-type'],
      contentLength: response.headers['content-length'],
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error('Erro ao gerar relatório FEFO Excel:', error);
      throw new Error(
        error.response?.data?.message || 'Erro ao gerar o relatório FEFO Excel'
      );
    } else {
      console.error('Erro desconhecido ao gerar relatório FEFO Excel:', error);
      throw new Error('Erro desconhecido');
    }
  }
};

// Retorna todas as lojas ativas, sem paginação (`GET /stores?all=true` devolve `{ items }`).
export const getAllStores = async (): Promise<{ id: string; nomeFantasia: string }[]> => {
  try {
    const { data } = await api.get<{ items: { id: string; nomeFantasia: string }[] }>("/stores", {
      params: { all: true },
    });
    return data.items;
  } catch (error) {
    throwApiError(error, "Erro ao buscar as lojas");
    return [];
  }
};
